/* @jsxImportSource react */

/* eslint-disable react/no-array-index-key */
import type { FragmentType } from '@packages/gql/generated/shopping';
import type { ColorTilesValuesFragmentFragmentDoc } from '@packages/gql/generated/shopping/ColorTilesValuesFragmentFragmentDoc';

import { unmask } from '@packages/gql/src/betterMasking';
import type { VariationSelectionOnSelectHandler } from '../types';
import { ColorTile } from './ColorTile/ColorTile.client';

/* GraphQL */ `
  fragment ColorTilesValuesFragment on ProductDimension {
    values {
      isSelected
      displayText
      ...ColorTileFragment
    }
  }
`;

export type ColorTilesDimensionProps = VariationSelectionOnSelectHandler & {
  /**
   * The GraphQL dimension data for the given product
   */
  data: FragmentType<typeof ColorTilesValuesFragmentFragmentDoc>;
};

/**
 * ColorTilesDimension to choose a product color on Detailview
 * */
export const ColorTilesDimension = ({ data, onSelect }: ColorTilesDimensionProps) => {
  const dimension = unmask<typeof ColorTilesValuesFragmentFragmentDoc>(data);

  return (
    <div className="mt-0.5 flex flex-row flex-wrap gap-1.5">
      {dimension.values.map((dimensionData, index) => (
        <ColorTile
          data={dimensionData}
          key={`ColorTilesDimensionColorTile${index}`}
          onSelect={onSelect}
        />
      ))}
    </div>
  );
};
